import { Inject, Injectable } from '@angular/core';
import { Environment } from '@thiememeulenhoff/types';
import { API_CONFIG, ApiGatewayConfig } from '../types';

@Injectable({
  providedIn: 'root',
})
export class ServicesService {
  constructor(@Inject(API_CONFIG) private config: ApiGatewayConfig) {} // eslint-disable-line

  public thip(endpoint: string, version = 2) {
    if (this.#useLocalThip()) {
      return `http://thip.localhost:8066/api/v${version}/${endpoint}`;
    }

    return `https://${this.#environmentApiPrefix()}thip.thiememeulenhoff.nl/api/v${version}/${endpoint}`;
  }

  public vesta(endpoint: string) {
    return `https://${this.#environmentApiPrefix()}vesta.thiememeulenhoff.nl/api/v2/${endpoint}`;
  }

  public thor(endpoint: string) {
    return `https://${this.#environmentApiPrefix()}thor.thiememeulenhoff.nl/api/v1/${endpoint}`;
  }

  public groupServices(endpoint: string) {
    return `https://${this.#environmentGroupServiceApiPrefix()}groupservices.thiememeulenhoff.nl/${endpoint}`;
  }

  public userService(endpoint: string) {
    const prefix = [
      Environment.Production,
      Environment.Staging,
      'prod',
    ].includes(this.config.environment)
      ? ''
      : `test.`;

    return `https://${prefix}user-service.thiememeulenhoff.nl/api/v1/${endpoint}`;
  }

  public edition(endpoint: string) {
    return `https://${this.#environmentApiPrefix()}edition.thiememeulenhoff.nl/secure/next/api/${endpoint}`;
  }

  public platform(endpoint: string) {
    const prefix = [
      Environment.Production,
      Environment.Staging,
      'prod',
    ].includes(this.config.environment)
      ? ''
      : `test.`;

    return `https://${prefix}platforms.thiememeulenhoff.nl/api/${endpoint}`;
  }

  public websocketGateway() {
    // TODO: https://tmjira.atlassian.net/browse/TLA-8268
    if (this.#isProduction()) {
      return 'wss://xigf9pwnj8.execute-api.eu-west-1.amazonaws.com';
    }
    return `wss://${this.#environmentApiPrefix()}edu-ws.thiememeulenhoff.nl`;
  }

  #isProduction() {
    // TODO: check why 'prod' is used as environment, and not 'production'
    return [Environment.Production, 'prod'].includes(this.config.environment);
  }

  #isStaging() {
    return [Environment.Staging, 'stag'].includes(this.config.environment);
  }

  #isAcceptance() {
    return [Environment.Acceptance, 'acc'].includes(this.config.environment);
  }

  #environmentGroupServiceApiPrefix() {
    if (this.#isProduction()) {
      return '';
    }

    // Groupservices ACC is actually stag, naming will be changed in the future for Groupservices
    if (this.#isStaging()) {
      return 'acc.';
    }

    // Group services acc is connected to Toegang PROD, our acc is connected to Toegang TEST, so we need to use test. prefix for group services in acc environment
    if (this.#useLocalThip() || this.#isAcceptance()) {
      return 'test.';
    }

    return `${this.config.environment}.`;
  }

  #useLocalThip() {
    return this.config.environment === Environment.ThipDevelopment;
  }

  #environmentApiPrefix() {
    if (this.#useLocalThip()) {
      return `${Environment.Test}.`;
    }
    return this.#isProduction() ? '' : `${this.config.environment}.`;
  }
}
